import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.965.762H.313v1.304h15.652V.762Zm-15 12.391V3.37h14.348v9.783c0 .36-.293.652-.653.652H8.79v1.957H7.487v-1.957h-5.87a.652.652 0 0 1-.651-.652ZM5.53 9.044 2.92 11.85H13.356L9.704 7.936l-2.607 2.793L5.53 9.044Zm1.304-2.413a1.304 1.304 0 1 1-2.608 0 1.304 1.304 0 0 1 2.608 0Z",
  fill: "#D5D4D6"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }